import { Nft } from "@/api/nfts/types";
import { useQuery } from "@tanstack/react-query";
import ordersApi from "@/api/orders/client";
import { useMemo } from "react";

import {
  BaseSignedOrder,
  OrderType,
  ReserveAuctionOrder,
} from "@/api/orders/types";
import { isExpiredInSeconds } from "@/shared/dates";
import { SettleAuctionButton } from "../../Buttons/SettleAuction";
import { PutOnSaleButton } from "../../Buttons/PutOnSale";

export interface Props {
  nft: Nft;
  auction: BaseSignedOrder;
  disable?: boolean;
}

export default function SellerTradeActions({ nft, auction, disable }: Props) {
  const { data: reserveBids } = useQuery({
    queryKey: ["reserve-bids-for-nft", nft.id],
    queryFn: () => ordersApi.getReserveBidsForNft(nft.id),
  });

  const isExpired = isExpiredInSeconds(auction?.expiresAt);

  const isPutOnSaleDisabled = useMemo(() => {
    if (auction?.type === OrderType.RESERVE_AUCTION && !!auction?.endingPrice) {
      return true;
    }

    return disable;
  }, [auction, disable]);

  return auction?.type === OrderType.RESERVE_AUCTION &&
    isExpired &&
    reserveBids?.length ? (
    <SettleAuctionButton
      auction={auction as ReserveAuctionOrder}
      bid={{ ...reserveBids[0], nft }}
    />
  ) : (
    <PutOnSaleButton
      nft={nft}
      disable={isPutOnSaleDisabled}
      isSaleExpired={isExpired}
    />
  );
}
